export const phoneNumberMaxLength = 20;
